import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  braveWallet,
  ledgerWallet,
  metaMaskWallet,
  omniWallet,
  rainbowWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { configureChains, createClient, createStorage } from 'wagmi';
import { bsc, polygonMumbai } from 'wagmi/chains';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';

export const initialChain =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? bsc : polygonMumbai;
export const whitelistChains =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? [bsc] : [polygonMumbai];

const { provider, chains, webSocketProvider } = configureChains(whitelistChains, [
  jsonRpcProvider({
    rpc: (chain) => {
      return { http: chain.rpcUrls.default.http[0] };
    },
  }),
]);

// Rainbowkit connectors list
const connectors = connectorsForWallets([
  {
    groupName: 'Suggested',
    wallets: [
      metaMaskWallet({ chains }),
      walletConnectWallet({ chains: whitelistChains }),
      trustWallet({ chains }),
    ],
  },
  {
    groupName: 'Others',
    wallets: [
      rainbowWallet({ chains }),
      ledgerWallet({ chains }),
      omniWallet({ chains }),
      braveWallet({ chains }),
    ],
  },
]);

// Wagmi client
const client = createClient({
  connectors,
  provider,
  autoConnect: true,
  storage: createStorage({ storage: window.localStorage }),
  webSocketProvider,
});

export { chains, client };
